import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ProgressCircle from '../../components/common/ProgressCircle';
import FormattedGB from '../../components/common/FormattedGB';
import { FormattedNumber } from 'react-intl';
// css
import '../../styles/components/analytics/OverlapPercentageAnalysisArea.scss';


function OverlapPercentageAnalysisArea({ disabled, areaTitle, percent, dataSourcesCount, totalDataSourcesCount, totalData, ciscoDataIndexed, nonCiscoDataIndexed }) {

  const classNames = classnames({
    'analytics__overlap-percentage-analysis-area': true,
    'analytics__overlap-percentage-analysis-area--disabled': disabled
  });

  const renderedDataSourcesCount = <span className='analytics__overlap-percentage-analysis-area__data-sources-count'>{dataSourcesCount}</span>;
  const renderedTotalDataSourcesCount = <span className='analytics__overlap-percentage-analysis-area__total-data-sources-count'>{totalDataSourcesCount}</span>;

  return (
    <li className={classNames}>
      <div className='row'>
        <div className='col-xs-3'>
          <ProgressCircle percent={percent} />
        </div>
        <div className='col-xs-9'>
          <h8 className='analytics__overlap-percentage-analysis-area__title'>{areaTitle}</h8>
          <h8 className='analytics__overlap-percentage-analysis-area__meta'>
            {renderedDataSourcesCount} of {renderedTotalDataSourcesCount} data sources<br />
            <FormattedGB value={totalData} perDay /> indexed
          </h8>
          <div className='analytics__overlap-percentage-analysis-area__cisco-split'>
            <FormattedNumber value={nonCiscoDataIndexed} maximumFractionDigits={1} /> GB/day Non Cisco
            <br />
            <FormattedNumber value={ciscoDataIndexed} maximumFractionDigits={1} /> GB/day Cisco Data
          </div>
        </div>
      </div>
    </li>
  );
}

OverlapPercentageAnalysisArea.defaultProps = {
  ciscoDataIndexed: 0,
  nonCiscoDataIndexed: 0
};

OverlapPercentageAnalysisArea.propTypes = {
  disabled: PropTypes.bool,
  areaTitle: PropTypes.string.isRequired,
  totalData: PropTypes.number.isRequired,
  percent: PropTypes.number.isRequired,
  dataSourcesCount: PropTypes.number.isRequired,
  totalDataSourcesCount: PropTypes.number.isRequired,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number
};

export default OverlapPercentageAnalysisArea;



// WEBPACK FOOTER //
// ./src/components/analytics/OverlapPercentageAnalysisArea.js